import { ClosedReason, SuretyAccountId } from "@inrev/common";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useRequest } from "../../../utils/request";
import { accountPreviewsQueryKey } from "../../previews/previews.keys";
import { accountQueryKey } from "../account.keys";

export const useCloseAccount = (accountId: SuretyAccountId) => {
	const queryClient = useQueryClient();
	const { post } = useRequest();

	const mutation = useMutation({
		mutationFn: async ({
			closedReason,
			note,
		}: {
			closedReason: ClosedReason;
			note?: string;
			onSuccess?: () => void;
		}) => {
			await post(`/v2/surety/accounts/${accountId}/close`, { closedReason, note }, "none");
			await Promise.all([
				queryClient.invalidateQueries({ queryKey: accountQueryKey(accountId) }),
				queryClient.invalidateQueries({ queryKey: accountPreviewsQueryKey() }),
			]);
		},
		onSuccess: (_, { onSuccess }) => {
			onSuccess?.();
		},
	});

	return {
		closeAccount: mutation.mutate,
		closeAccountLoading: mutation.isPending,
		closeAccountError: mutation.error,
		dismissCloseAccountError: () => {
			mutation.reset();
		},
	};
};
